import { render } from "./EditCustomer.vue?vue&type=template&id=e0c00ebc&ts=true"
import script from "./EditCustomer.vue?vue&type=script&lang=ts"
export * from "./EditCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__